import * as React from "react"

const RackTrain = (props: any) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_4543_12589)">
      <path d="M1.82704 17.0339L16.1443 13.1976C16.7864 13.0256 17.1375 12.2515 16.9281 11.4698L15.0309 4.38936C14.6116 2.82458 13.2309 1.83613 11.9455 2.18054L1.82703 4.8918" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M1.82727 12.4806L16.1693 8.63766" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M1.82739 7.9273L15.0312 4.38937" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M4.95141 11.2162L4.00281 7.67592" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10"/>
      <path d="M10.4952 9.73065L9.54663 6.19041" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10"/>
      <path d="M1.77246 20.0002L20.1251 15.0826" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeDasharray="1.8 1.2"/>
    </g>
    <defs>
      <clipPath id="clip0_4543_12589">
        <rect width="22" height="22" fill="white"/>
      </clipPath>
    </defs>
</svg>
)

export default RackTrain
